import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import moment from 'moment';

import { ElementLink } from '../../components';

export class HappeningCellView extends Component {
  render() {
    const { happening, style, trRef } = this.props;

    function format(date) {
      return moment(date).format('MM-DD-YYYY h:mm a');
    }

    return (
      <ElementLink
        element="tr"
        to={`/happenings/${happening.id}/edit`}
        className="happening-cell"
        style={style}
        elementRef={trRef}
      >
        <td className="happening-cell-title">{happening.title}</td>
        <td className="happening-cell-url">{happening.url}</td>
        <td className="happening-cell-start-date">
          {format(happening.startDate)}
        </td>
        <td className="happening-cell-end-date">{format(happening.endDate)}</td>
      </ElementLink>
    );
  }
}

export default createFragmentContainer(HappeningCellView, {
  happening: graphql`
    fragment HappeningCell_happening on HeroOffer {
      id
      title
      url
      imageUrl
      startDate
      endDate
    }
  `,
});
